// The `ellis` API owns this field name (T051). It is read through this helper and nowhere else,
// so a rename on the server side is a one-line change. Lives in lib/ rather than on a page
// because four call sites — EntityApplicationPage and its container (which experience to render),
// EntityProgressBar (how to label step 2) and ApprovalStatusContainer — must reach the same
// answer; independent reads could disagree and show an applicant a "Download Application" step
// above an embedded form.
export default function hasFormstackHandoff(state) {
  return Boolean(state && state.application && state.application.formstackHandoffAt);
}
